import React, { Component } from 'react';
import { connect } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import { injectIntl, intlShape } from 'react-intl';
import { Card, CardBody, CardHeader, Button } from 'reactstrap';
import { setRecoveryPassword } from 'actions/Auth';
import { addressString } from 'components/FormattedAddress';
import { checkPasswordRequirements } from 'helperfunctions';
import Moment from 'moment';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Link } from 'react-router-dom';

class PasswordRecovery extends Component {
	constructor(props) {
		super(props);
		this.state = {
			passwordValue: '',
			passwordRepeatValue: '',
			invalid: {
				password: false,
				passwordRepeat: false
			},
			showSuccess: false,
			showError: false
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.setRecoveryPasswordLoading && !this.props.setRecoveryPasswordLoading)
			this.setState({ showSuccess: !this.props.setRecoveryPasswordError, showError: this.props.setRecoveryPasswordError });
	}

	checkPasswords = () => {
		const { passwordValue, passwordRepeatValue } = this.state;
		// Prüfen ob die eingegebenen Passwörter übereinstimmen
		if (passwordValue !== passwordRepeatValue) return this.setState({ invalid: { ...this.state.invalid, passwordRepeat: true } });
		// Prüfen ob das neue Passwort die Anforderungen erfüllt
		if (!checkPasswordRequirements(passwordValue, { minPasswordLength: 8, minPasswordCatgories: 3 }))
			return this.setState({ invalid: { ...this.state.invalid, password: true } });
		// Passwort absenden
		this.props.setRecoveryPassword(this.props.match.params.userId, this.props.match.params.key, passwordValue);
	};

	render() {
		const { invalid, passwordRepeatValue, passwordValue } = this.state;
		return (
			<div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3 flex-column">
				<div className="app-login-main-content">
					<div className="app-logo-content d-flex align-items-center justify-content-center bg-grey">
						<Link className="logo-lg" to="/signin" title="Jambo">
							<img src="assets/images/icon-meldooplus.svg" alt="Meldo-Icon" title="Meldoo" height={100} />
						</Link>
					</div>

					<div className="app-login-content">
						<div className="app-login-header mb-4">
							<h1>
								<IntlMessages id="passwordRecovery.title" />
							</h1>
						</div>
						<p>
							<IntlMessages id="passwordRecovery.info" />
						</p>
						<div className="app-login-form">
							<div className="form-group">
								<input
									className={`form-control form-control-lg ${invalid.password ? 'is-invalid' : ''}`}
									value={passwordValue}
									onChange={m =>
										this.setState({
											passwordValue: m.target.value,
											invalid: { passwordNew: false }
										})
									}
									type="password"
									placeholder={this.props.intl.formatMessage({
										id: 'passwordExpiredModal.passwordNew'
									})}
									disabled={this.props.setRecoveryPasswordLoading}
								/>
								<div className="invalid-feedback">
									<IntlMessages id="passwordExpiredModal.passwordNew.invalidText" />
								</div>
								<small className="form-text text-muted text-left small">
									<IntlMessages
										id="common.passwordRequirementsInfo"
										values={{
											minPasswordLength: 8,
											minPasswordCategories: 3
										}}
									/>
								</small>
							</div>
							<div className="form-group">
								<input
									className={`form-control form-control-lg ${invalid.passwordRepeat ? 'is-invalid' : ''}`}
									value={passwordRepeatValue}
									onChange={m =>
										this.setState({
											passwordRepeatValue: m.target.value,
											invalid: { passwordRepeat: false }
										})
									}
									type="password"
									placeholder={this.props.intl.formatMessage({
										id: 'passwordExpiredModal.passwordRepeat'
									})}
									disabled={this.props.setRecoveryPasswordLoading}
								/>
								<div className="invalid-feedback">
									<IntlMessages id="passwordExpiredModal.passwordRepeat.invalidText" />
								</div>
							</div>

							<div className="mb-3 d-flex flex-column align-items-start justify-content-between">
								<Button
									onClick={this.checkPasswords}
									color="primary"
									// disabled={this.props.setRecoveryPasswordLoading}
								>
									<IntlMessages id="passwordRecovery.action" />
								</Button>
							</div>
						</div>
					</div>
				</div>
				<footer className="app-footer">
					<div className="d-flex flex-row justify-content-between">
						<div>
							<span>
								&copy;{` ${Moment().year()} `}
								<a href="https://www.leanact.de/">leanact GmbH</a>. <IntlMessages id="footer.allRightsReserved" />.
							</span>
						</div>
						<div className="ml-3">
							<a href="https://www.leanact.de/impressum/">
								<IntlMessages id="impressum.title" />
							</a>
						</div>
						<div className="ml-3">
							<a href="https://www.leanact.de/agb-und-datenschutz/">
								<IntlMessages id="footer.dataprotection" />
							</a>
						</div>
					</div>
				</footer>
				<SweetAlert
					show={this.state.showSuccess}
					success
					title={<IntlMessages id="passwordRecovery.response.success" />}
					onConfirm={() => this.props.history.push('/signin')}
				>
					<IntlMessages id="passwordRecovery.response.success.info" />
				</SweetAlert>
				<SweetAlert
					show={this.state.showError}
					error
					title={<IntlMessages id="passwordRecovery.response.success" />}
					onConfirm={() => this.props.history.push('/signin')}
				>
					{}
				</SweetAlert>
			</div>
		);
	}
}

function mapStateToProps({ auth }) {
	const { setRecoveryPasswordLoading, setRecoveryPasswordError } = auth;
	return { setRecoveryPasswordLoading, setRecoveryPasswordError };
}

PasswordRecovery.propTypes = {
	intl: intlShape.isRequired
};

export default connect(
	mapStateToProps,
	{ setRecoveryPassword }
)(injectIntl(PasswordRecovery));



// WEBPACK FOOTER //
// ./containers/PasswordRecovery/index.js